module.exports = __webpack_public_path__ + "static/kampire-9754601604bc577daf0d912511ab632f.png";